import dynamic from "next/dynamic";

export const MODAL_COLLECTION = {
  CONFIRMATION: dynamic(() => import("@/components/modals/modal_confirmation"), { ssr: false }),
  NEED_LIST_FILES: dynamic(() => import("@/components/needs_list/need_list_file_record_list"), { ssr: false }),
  MY_NEED_LIST_FILES: dynamic(() => import("@/components/needs_list/my_need_list_file_record_list"), { ssr: false }),
  LOAN_SUMMARY_WRAPPER: dynamic(
    () => import("@/features/LoanSummary/Management/components/modals/LoanSummaryDetail/LoanSummaryDetailWrapper"),
    { ssr: false },
  ),
  CONFIRMATION_V2: dynamic(() => import("@/components/modals/modal_confirmation_v2"), { ssr: false }),
  NEEDS_LIST_TEMPLATE_DOCUMENTS: dynamic(
    () => import("@/components/needs_list_templates/lists/needs_list_template_documents"),
    {
      ssr: false,
    },
  ),
  BROKER_BORROWER_NEEDS_LIST_FILES: dynamic(() => import("@/components/loan/broker/broker_needs_list_files"), {
    ssr: false,
  }),
  BORROWER_NEEDS_LIST_FILES: dynamic(() => import("@/features/BorrowerPortal/components/MyNeedsListFileModal"), {
    ssr: false,
  }),
  BORROWER_NEEDS_LIST_TEMPLATES: dynamic(
    () => import("@/features/BorrowerPortal/components/MyNeedsListTemplateModal"),
    {
      ssr: false,
    },
  ),
  BORROWER_APPLICATION_PARAMETERS: dynamic(
    () => import("@/components/loan/loan_form/borrower_application_parameters_form"),
    {
      ssr: false,
    },
  ),
  BORROWER_NEEDS_LIST_INSTRUCTIONS: dynamic(
    () => import("@/components/loan/broker/broker_needs_list_borrower_instructions"),
    {
      ssr: false,
    },
  ),
  LENDING_PROGRAM_UPDATE_FORM: dynamic(
    () =>
      import("@/features/LendingProgram/components/LendingProgramUpdateForm/LendingProgramUpdateFormWrapper").then(
        c => c.default,
      ),
    {
      ssr: false,
    },
  ),
  LENDING_PROGRAM_CREATE_FORM: dynamic(
    () =>
      import("@/features/LendingProgram/components/LendingProgramWizard/LendingProgramWizardWrapper").then(
        c => c.default,
      ),
    {
      ssr: false,
    },
  ),
  CLOSE_LENDER_BOARD_CONFIRMATION: dynamic(
    () => import("@/features/LenderBoard/Management/components/modals/CloseLenderBoard/CloseLenderBoardModal"),
    {
      ssr: false,
    },
  ),
  MESSAGE_REQUEST_MODAL: dynamic(() => import("@/features/LenderHub/Deal/components/modals/MessageRequestModal"), {
    ssr: false,
  }),
  CLOSED_REASON_MODAL: dynamic(() => import("@/features/LenderHub/Deal/components/modals/ClosedReasonModal"), {
    ssr: false,
  }),
  CLOSE_LENDER_HUB_DEAL_CONFIRMATION: dynamic(
    () => import("@/features/LenderHub/Deal/components/modals/CloseLenderHubDealConfirmationModal"),
    {
      ssr: false,
    },
  ),
  LENDER_HUB_OFFER_WIZARD: dynamic(
    () => import("@/features/LenderHub/Offer/components/LenderHubOfferWizard/LenderHubOfferWizardModal"),
    {
      ssr: false,
    },
  ),
  LENDER_HUB_OFFER_UPDATE: dynamic(
    () => import("@/features/LenderHub/Offer/components/LenderHubOfferDetail/LenderHubOfferDetailContainer"),
    {
      ssr: false,
    },
  ),
  LENDER_BOARD_OFFER_WIZARD: dynamic(
    () => import("@/features/LenderBoard/Offer/components/LenderBoardOfferWizard/LenderBoardOfferWizardModal"),
    {
      ssr: false,
    },
  ),
  LENDER_BOARD_OFFER_UPDATE: dynamic(
    () => import("@/features/LenderBoard/Offer/components/LenderBoardOfferDetail/LenderBoardOfferDetailContainer"),
    {
      ssr: false,
    },
  ),
  LENDER_BOARD_OFFER_VIEW: dynamic(
    () => import("@/features/LenderBoard/Offer/components/LenderBoardOfferView/LenderBoardOfferViewContainer"),
    {
      ssr: false,
    },
  ),
  MARKETPLACE_CONNECTION_REQUEST_MODAL: dynamic(
    () => import("@/features/LenderHub/Deal/MarketplaceDealsPage/components/modals/MarketplaceConnectionRequestModal"),
    {
      ssr: false,
    },
  ),
  MARKETPLACE_ADD_TO_PIPELINE_MODAL: dynamic(
    () => import("@/features/LenderHub/Deal/MarketplaceDealsPage/components/modals/MarketplaceAddToPipelineModal"),
    {
      ssr: false,
    },
  ),
  MARKETPLACE_SEND_REMINDER_MODAL: dynamic(
    () => import("@/features/LenderHub/Deal/MarketplaceDealsPage/components/modals/MarketplaceSendReminderModal"),
    {
      ssr: false,
    },
  ),
};

export const MODAL_SIZES = {
  SM: "SM",
  MD: "MD",
  LG: "LG",
  XL: "XL",
};
